import React from 'react';
import * as d3 from 'd3';
import { widgetConfigurationProps, dimensionsProps } from "./interfaces"; 

/**
 * Sample Widget to work out and test layouts, resizing, and properties
 *
 * @param dimensions
 * @param data
 * @param backgroundColor
 * @returns {*}
 * @constructor
 */
export const TestWidget: React.FC<TestWidgetProps> = ({ dimensions, data, title, backgroundColor }) => {
  return (
    <svg width={dimensions.width} height={dimensions.height} style={{ background: backgroundColor }}>
      {data.map((label, i) => {
        const details = {
          x: Math.random() * dimensions.width,
          y: Math.random() * dimensions.height,
          fontSize: Math.random() * 10 + 10,
          color: d3.interpolateMagma(i / data.length),
          rotate: Math.random() * 360,
        };
        return (
          <text key={i}
                x={details.x}
                y={details.y}
                fill={details.color}
                transform={`rotate(${details.rotate} ${details.x} ${details.y})`}
                style={{
                  fontSize: `${details.fontSize}px`,
                  textAnchor: 'middle',
                  dominantBaseline: 'central',
                }}
          >
            {label}
          </text>
        );
      })}
    </svg>
  );
};


interface TestWidgetProps {
  data: number[]
  backgroundColor: string,
  title: string,
  dimensions: dimensionsProps
}